import { Column } from "primereact/column";
import { DataTable } from "primereact/datatable";
import { useEffect, useRef, useState } from "react";
import { Fetch } from "../../../shared/Fetch";

interface IProps {
  reload: boolean;
  toast: any;
}

export interface IMassMailInhouseCompanySetting {
  id?: number;
  company_Name?: string;
  no_of_email_fresher?: number | null;
  no_of_email_midlevel?: number | null;
  no_of_email_exprience?: number | null;
  no_Of_Months_Fresher?: number | null;
  no_Of_Months_MidLevel?: number | null;
  no_Of_Months_Experienced?: number | null;
  no_Of_Selectingcount?: number | null;
  max_Mail_Count?: number;
  updated_By?: string;
  updated_At?: Date;
}

export const MassMailInhouseCompanySettingTable = (props: IProps) => {
  const [tableData, setTableData] = useState({ tableData: [], loading: false } as { tableData: Array<IMassMailInhouseCompanySetting>; loading: boolean });
  const dt = useRef<any>(null);

  const loadTableData = async () => {
    setTableData({ tableData: tableData.tableData, loading: true });
    const response = await Fetch("MassMail/getMassMailInhouseCompanySetting", "GET", null, null, props.toast);
    if (response) {
      const data: Array<IMassMailInhouseCompanySetting> = await response.json();
      console.log(data);
      setTableData({ tableData: data, loading: false });
    }
  };

  useEffect(() => {
    loadTableData();
  }, [props.reload]);

  return (
    <>
      <DataTable style={{ border: "1px solid rgba(105,105,105,0.17)", borderTopWidth: "0" }} size="small" ref={dt} value={tableData.tableData} emptyMessage="No Data found." loading={tableData.loading} showGridlines stripedRows responsiveLayout="scroll">
        <Column field="company_Name" header="Company" />

        <Column field="max_Mail_Count" header="Max Email Sending Count" />
        <Column field="no_Of_Months_Fresher" header="No of Months for Fresher " className="bg-blue-300 font-bold" />
        <Column field="no_Of_Months_MidLevel" header="No of Months for Mid-level  " className="bg-green-300 font-bold" />
        <Column field="no_Of_Months_Experienced" header="No of Months for Exprience" className="bg-teal-300 font-bold" />
        <Column field="no_of_email_fresher" header="No of Email for Fresher " className="bg-blue-200 font-bold" />
        <Column field="no_of_email_midlevel" header="No of Email for  Mid-level " className="bg-green-200 font-bold" />
        <Column field="no_of_email_exprience" header="No of Email for  Exprience" className="bg-teal-200 font-bold" />
        <Column field="no_Of_Selectingcount" header="Maximum Selecting Count At Once" />

        <Column field="updated_By" header="Updated By" />
      </DataTable>
    </>
  );
};
